export class Step {
  name: string;
  completed: boolean;
  isNext: boolean;
  constructor(name: string) {
    this.name = name;
    this.completed = false;
    this.isNext = false;
  }
}
